import React from 'react';

const SupportPage = () => {
  // FAQ data could be moved to a separate file or state if it becomes more complex
  const generalFaqs = [
    {
      question: 'How do I download your apps?',
      answer: 'Our apps are available on both iOS (Apple App Store) and Android (Google Play Store). You can access the download links directly from our website or search for the app name in your device\'s app store.'
    },
    {
      question: 'Do your apps work offline?',
      answer: 'Yes, once you\'ve downloaded our apps and the necessary data, they can be used without an internet connection. Some features may require online access for updates or synchronization.'
    },
    {
      question: 'How much does GTO Preflop cost?',
      answer: 'GTO Preflop offers weekly, monthly, and yearly subscription plans. Subscribe to unlock all positions, stack sizes, game formats, and advanced training features. Visit the app for current pricing.'
    }
  ];

  const gtopreflopFaqs = [
    {
      question: 'How accurate are the preflop ranges?',
      answer: 'Our ranges are created using advanced GTO solver technology and are regularly updated to reflect the latest developments in poker strategy. They represent mathematically optimal play in the specified scenarios.'
    },
    {
      question: 'Can I customize the ranges?',
      answer: 'Currently, the ranges are pre-solved and cannot be customized. However, we offer ranges for various stack depths and positions to cover most common scenarios.'
    }
  ];

  const pocketTrainerFaqs = [
    {
      question: 'How do I track my progress?',
      answer: 'The app includes a progress tracking feature that shows your performance over time, including accuracy rates and areas for improvement.'
    }
  ];

  const bountySolverFaqs = [
    {
      question: 'How does the solver calculate optimal bounty decisions?',
      answer: 'The solver uses mathematical models to determine the expected value (EV) of different decisions in mystery bounty tournaments, taking into account the tournament structure and prize pool distribution.'
    }
  ];

  return (
    <main className="legal-page">
      <div className="container">
        <div className="legal-content">
          <h1>Support</h1>
          <p className="subtitle">We're here to help with all Peka Software applications</p>
          
          <div className="legal-section">
            <h2>Frequently Asked Questions</h2>
            
            <h3>General Questions</h3>
            {generalFaqs.map((faq, index) => (
              <div className="faq-item" key={`general-${index}`}>
                <h4>{faq.question}</h4>
                <p>{faq.answer}</p>
              </div>
            ))}
            
            <h3>GTO Preflop App</h3>
            {gtopreflopFaqs.map((faq, index) => (
              <div className="faq-item" key={`gto-${index}`}>
                <h4>{faq.question}</h4>
                <p>{faq.answer}</p>
              </div>
            ))}
            
            <h3>GTO Pocket Trainer</h3>
            {pocketTrainerFaqs.map((faq, index) => (
              <div className="faq-item" key={`pocket-${index}`}>
                <h4>{faq.question}</h4>
                <p>{faq.answer}</p>
              </div>
            ))}

            <h3>Mystery Bounty Solver</h3>
            {bountySolverFaqs.map((faq, index) => (
              <div className="faq-item" key={`bounty-${index}`}>
                <h4>{faq.question}</h4>
                <p>{faq.answer}</p>
              </div>
            ))}
          </div>

          <div className="legal-section">
            <h2>Contact Support</h2>
            <p>If you couldn't find answers to your questions above, please feel free to contact our support team:</p>
            
            <div className="contact-info">
              <p><strong>Email:</strong> <a href="mailto:petter@pekasoftware.com">petter@pekasoftware.com</a></p>
              <p>We aim to respond to all inquiries within 1-2 business days.</p>
            </div>
            
            <p>When contacting support, please include:</p>
            <ul>
              <li>The name of the app you're using</li>
              <li>Your device model and operating system version</li>
              <li>A detailed description of the issue</li>
              <li>Screenshots if applicable</li>
            </ul>
          </div>
        </div>
      </div>
    </main>
  );
};

export default SupportPage; 